// Construction de la route par défaut de l'espace client, isolée ici pour être testable : c'est
// l'interpolation d'un `totemId` absent qui envoyait l'app sur `/totem/undefined` — une URL qui matche la
// route des sites, rend un 404, et dont même un rechargement ne sortait pas.

/** `null` quand aucun site n'est accessible : il n'y a alors PAS d'URL à construire. */
export function getDefaultTotemPath(totemId?: string | null): string | null {
    return totemId ? `/totem/${totemId}` : null;
}

/** URLs `/totem/undefined` déjà en circulation (onglets ouverts, favoris) : à ramener sur la route par défaut. */
export function isBrokenTotemIdInUrl(totemIdFromUrl?: string): boolean {
    return totemIdFromUrl === 'undefined' || totemIdFromUrl === 'null';
}
